import {useEffect, useState, useRef} from 'preact/hooks';

import {serviceMode} from '~/locals/qianfan/index';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'serviceModeType';
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';

export default function ServiceMode() {
    const {
        title,
        titleMobile,
        grayIcon,
        whiteIcon,
        content: {left, right}
    } = serviceMode;

    const {screenWidth} = useQfScreen();
    useCptDuration(id, {
        name: `${applicationName}-${title}-停留时长`
    });

    return (
        <div className="service-mode-type" id={id}>
            <div className="module-wrapper">
                <div className="module-container">
                    <div className="service-mode-content">
                        <h2 className={`title ${moduleTitleClassName}`}>{screenWidth < 500 ? titleMobile : title}</h2>
                        <div className={`service-mode-box ${moduleContentClassName}`}>
                            {/* 公有云 */}
                            <div className="service-mode-left">
                                <h3 className="title">{left.title}</h3>
                                <div className="content">
                                    <img src={screenWidth < 768 ? whiteIcon : grayIcon} alt="icon" />
                                    <span>{left.content}</span>
                                </div>
                                <div className="desc-btn-box">
                                    <div className="desc-box">
                                        {left.desc.map((des, cindex) => {
                                            return (
                                                <div className="desc" key={des}>
                                                    <img
                                                        src={require('assets/wenxin/check-mark.png').default}
                                                        alt="icon"
                                                    />
                                                    <span>{des}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className="btn-box">
                                        {left.btnList.map(item => {
                                            const {id, text, link, trackInfo} = item;
                                            return (
                                                <a
                                                    className="btn-gradual btn"
                                                    key={id}
                                                    href={link}
                                                    {...trackInfo}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span className="btn-text">{text}</span>
                                                </a>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            {/* 私有化+软硬一体 */}
                            <div className="service-mode-right">
                                {right.map((item, index) => {
                                    const {title, id, desc, btn} = item;
                                    return (
                                        <div className="service-mode-right-box" key={item.id}>
                                            <div className="content">
                                                <h3 className="title">{item.title}</h3>
                                                <div className="desc">
                                                    <img src={grayIcon} alt="icon" />
                                                    <span>{desc}</span>
                                                </div>
                                            </div>
                                            <div className="btn-box">
                                                <a
                                                    className="btn-gradual btn"
                                                    href={btn.link}
                                                    {...btn.trackInfo}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span className="btn-text">{btn.text}</span>
                                                </a>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
